import { companionCities } from './companionCities.data';
import { regionFilters } from './constants';
import type { CompanionRegion } from './types';

export type RegionMeta = {
  region: CompanionRegion;
  description: string;
  tone: string;
  cityCount: number;
};

const regionDescriptions: Record<CompanionRegion, { description: string; tone: string }> = {
  ایران: {
    description: 'قلب شبکه؛ بیشترین تمرکز همراهان و دوره‌های حضوری.',
    tone: '#1c3b9b',
  },
  خاورمیانه: {
    description: 'پل ارتباطی بین ایران و جهان؛ شهرهای پرتردد منطقه.',
    tone: '#0f766e',
  },
  اروپا: {
    description: 'گسترش جامعه در کلان‌شهرهای اروپایی با روایت‌های متنوع.',
    tone: '#7c3aed',
  },
  آسیا: {
    description: 'همراهان از افغانستان و نقاط در حال گسترش در شرق.',
    tone: '#c11277',
  },
  آفریقا: {
    description: 'حلقه‌های در حال شکل‌گیری — به‌زودی روایت‌های تازه.',
    tone: '#b45309',
  },
  آمریکا: {
    description: 'کالیفرنیا، فلوریدا، تورنتو و جامعه فارسی‌زبان شمال آمریکا.',
    tone: '#2563eb',
  },
  اقیانوسیه: {
    description: 'اتصال از سیدنی با تمرین آنلاین و اختلاف زمانی.',
    tone: '#0891b2',
  },
};

export const continentMetaList: RegionMeta[] = regionFilters
  .filter((r): r is CompanionRegion => r !== 'همه')
  .map((region) => ({
    region,
    cityCount: companionCities.filter((c) => c.region === region).length,
    ...regionDescriptions[region],
  }));
